import { ModelState } from './model';
import { ModelError } from './error';
export var ControlFields;
(function (ControlFields) {
    ControlFields["Error"] = "error";
    ControlFields["Result"] = "result";
    ControlFields["State"] = "state";
    ControlFields["Revision"] = "revision";
})(ControlFields || (ControlFields = {}));
const fields = Object.values(ControlFields);
export class ModelControl {
    events = events();
    transaction = transaction();
    get [ControlFields.State]() {
        if (this[ControlFields.Error]) {
            return ModelState.Error;
        }
        else if (this[ControlFields.Result]) {
            return ModelState.Ready;
        }
        else {
            return ModelState.Initial;
        }
    }
    [ControlFields.Error] = null;
    [ControlFields.Result] = null;
    [ControlFields.Revision] = 1;
    set(data) {
        this.transaction(() => {
            if (data instanceof ModelError) {
                this[ControlFields.Error] = data || null;
                this[ControlFields.Result] = null;
            }
            else {
                this[ControlFields.Error] = null;
                this[ControlFields.Result] = data || null;
            }
        }, (changes) => {
            changes.forEach(([field, prev, curr]) => {
                this.events.notify(field, prev, curr);
            });
            this.events.notify(ControlFields.Revision, this[ControlFields.Revision], ++this[ControlFields.Revision]);
        });
    }
    subscribe(field, handler) {
        return this.events.subscribe(field, handler);
    }
}
const call = (...args) => (fn) => fn(...args);
function transaction() {
    return function transaction(tx, onchange) {
        const state = fields.reduce((acc, field) => {
            acc[field] = this[field];
            return acc;
        }, {});
        tx();
        const changed = fields.filter((field) => this[field] !== state[field]);
        if (changed.length) {
            onchange(changed.map((field) => [field, state[field], this[field]]));
        }
    };
}
function events() {
    const subscriptions = fields.reduce((acc, field) => {
        acc[field] = new Set();
        return acc;
    }, {});
    return {
        subscribe(field, handler) {
            subscriptions[field].add(handler);
            return () => {
                subscriptions[field].delete(handler);
            };
        },
        notify(field, prev, next) {
            if (subscriptions[field].size) {
                [...subscriptions[field]].forEach(call(next, prev));
            }
        },
    };
}
